/* eslint-disable */
export const inIcon = {
  data: `<svg width="13" height="14" viewBox="0 0 13 14" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.744568" y="0.984375" width="12" height="12" rx="6" fill="#00A558"/>
<path d="M4.08444 6.98346H9.40491M9.40491 6.98346L7.40973 4.98828M9.40491 6.98346L7.40973 8.97863" stroke="white" stroke-width="0.918209" stroke-linecap="round" stroke-linejoin="round"/>
</svg>`,
  name: 'in' as const,
};
